import { createSlice } from '@reduxjs/toolkit';

import type { PendenciasState } from '@/types/pendencias/pendenciasTypes';

import { fetchPendencias } from './services';

const initialState: PendenciasState = {
  tarefas: [],
  dashboard: null,
  loading: false,
  error: null,
};

const pendenciasSlice = createSlice({
  name: 'pendencias',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendencias.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendencias.fulfilled, (state, action) => {
        state.loading = false;
        state.tarefas = action.payload.tarefas;
        state.dashboard = action.payload.dashboard;
      })
      .addCase(fetchPendencias.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Erro ao carregar pendências';
      });
  },
});

export const pendenciasReducer = pendenciasSlice.reducer;
